import React from 'react';
import PropTypes from 'prop-types';
import {
	Wrapper,
	SelectWrapper,
	StyledSelect,
	Label,
	SelectLabel,
	SelectLabelPlaceholder,
	Arrow,
} from './styles';

export class Select extends React.Component {
	static propTypes = {
		label: PropTypes.string,
		name: PropTypes.string.isRequired,
		options: PropTypes.arrayOf(
			PropTypes.oneOfType([PropTypes.object, PropTypes.string])
		).isRequired,
		value: PropTypes.string,
		onChange: PropTypes.func.isRequired,
	};

	render() {
		const { label, name, options, value, onChange, ...otherProps } = this.props;

		return (
			<Wrapper {...otherProps}>
				<Label>{label}</Label>
				<SelectWrapper>
					<StyledSelect name={name} value={value || ''} onChange={onChange}>
						{!value && <option value="" disabled>{`Select ${label}`}</option>}
						{options.map(getOptionByValue)}
					</StyledSelect>
					{value ? (
						<SelectLabel>
							{value}
							<Arrow />
						</SelectLabel>
					) : (
						<SelectLabelPlaceholder>
							{`Select ${label}`}
							<Arrow />
						</SelectLabelPlaceholder>
					)}
				</SelectWrapper>
			</Wrapper>
		);
	}
}

const getOptionByValue = value => {
	if (value.key && value.value) {
		return (
			<option key={value.key} value={value.value}>
				{value.value}
			</option>
		);
	}

	return (
		<option key={value} value={value}>
			{value}
		</option>
	);
};
